export class APIError {
  message: string = '';
  status: number = -1;
  error: number = -1;

  constructor(message: string, status: number, error: number) {
    this.message = message;
    this.status = status;
    this.error = error;
  }
}
